module.exports = __webpack_public_path__ + "img/CA_DIGITAL.723da36b.png";